"use client";

import { Banner } from "@/components/Banner";
import { CardBox } from "../CardBox";
import { Typography } from "../Typography";
import { Link } from "../Link";
import { ReasonsModuleProps } from "./types";

import "./styles.scss";

export const ReasonsModule = ({ data, wrapperSize, setSource }: ReasonsModuleProps) => {
  const { content, title, actionButton, richtext, amplitudeEvent } = data;

  return (
    <Banner
      big
      light
      wrapperSize={wrapperSize}>
      <div className="reasons-module">
        <div className="reasons-module-header">
          <Typography
            Tag={"h2"}
            spacing={8}>
            {title}
          </Typography>
          {richtext?.map((item, i: number) => (
            <Typography
              key={i}
              Tag={item.tag}
              size={item.size}
              spacing={item.spacing}>
              {item.list
                ? item.list.map((e, i) => (
                    <li key={i}>{<span dangerouslySetInnerHTML={{ __html: e["item"] }}></span>}</li>
                  ))
                : item.content}
            </Typography>
          ))}
        </div>
        <div className="reasons-module-content">
          {content.map((item, i) => (
            <CardBox
              item={item}
              key={i}
              shadow
              className="reasons-card"
            />
          ))}
        </div>
        {actionButton && (
          <Link
            href={actionButton.href}
            className="bold-text button button--extralarge card-action-button"
            type="button"
            onClick={() => amplitudeEvent && setSource(amplitudeEvent)}
            nofollow>
            {actionButton.label}
          </Link>
        )}
      </div>
    </Banner>
  );
};
